import type { FC, SVGProps } from "react";

const IconSearchError: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M11.5 6.5L6.5 11.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.5 6.5L11.5 11.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19.0002 19.0002L14.7002 14.7002" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconSearchError;
